export default __webpack_public_path__ + "media/images/paylogos/gray/visa_verified@2x-b8402adfe0263c21555b86f15eb12507.png";